import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@heroui/react';
import { renderNotice } from '@/pages/catalogImport/notices';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import type { RecheckState } from '../../useProductsStep';

type RecheckFailureAlertProps = {
    recheck: RecheckState;
};

/**
 * Why the last Re-check did not answer, under the step's header: a refusal's
 * sentence, or that there was no answer; nothing while none failed.
 */
export const RecheckFailureAlert: React.FC<RecheckFailureAlertProps> = ({
    recheck,
}) => {
    const { t } = useTranslation('pages');
    if (recheck.status === 'idle') {
        return null;
    }
    return (
        <Alert
            status="danger"
            {...getNodeTestIdProp('catalog-import-products-recheck-alert')}
        >
            <Alert.Indicator />
            <Alert.Content>
                <Alert.Title>
                    {t('catalogImport.products.recheckFailed.title')}
                </Alert.Title>
                <Alert.Description>
                    {recheck.status === 'refused'
                        ? renderNotice(t, recheck.notice)
                        : t('catalogImport.products.recheckFailed.description')}
                </Alert.Description>
            </Alert.Content>
        </Alert>
    );
};
